"use client";

import type { DocumentNode } from "graphql";
import { imageTileCardDataFragmentDoc, Maybe, _IContent, imageTileCard } from "@gql/graphql";
import { ImageTiles } from "@nrldigitaltechnology/ui-community";
import { ImageTilesProps } from "@nrldigitaltechnology/ui-community/dist/components/ImageTiles/types";
import { useWindowDimension } from "@/hooks/useWindowDimension";


type ImageTileCardDataProps = {
  data: Maybe<imageTileCard> | undefined;
  inEditMode?: boolean;
};

// Extend the component type to include the static getDataFragment method
interface ImageTileCardProps
  extends React.FC<ImageTileCardDataProps> {
  getDataFragment: () => [string, DocumentNode];
}

const ImageTileCard: ImageTileCardProps = ({
  data,
  inEditMode = false,
}: ImageTileCardDataProps) => {
  // Destructure with safe defaults

  const dimension = useWindowDimension();
  const {

  } = data || {};


  const onClickImageTile = () => {
    if (data?.ctaUrl?.default)
      window.open(data?.ctaUrl?.default || "", "_blank")?.focus();
  }

  const dataMapping: ImageTilesProps = {
    backgroundImage: data?.backgroundImage?.url?.default || "",
    logo: "",
  }



  return (
    <div className="">
       <ImageTiles overlay={false} width="230px" height="130px" {...dataMapping} onClick={onClickImageTile} />
      {/* <ImageTiles overlay={false} width={custWidth} height="130px" {...dataMapping} onClick={onClickImageTile} /> */}
    </div>

  );
};

ImageTileCard.displayName = "Image Tile Card";

ImageTileCard.getDataFragment = () => [
  "InformationMediaCardDataProps",
  imageTileCardDataFragmentDoc];

// Attach the data fragment to the component
ImageTileCard.getDataFragment = (): [string, DocumentNode] => [
  "InformationMediaCardDataProps",
  imageTileCardDataFragmentDoc,
];

export default ImageTileCard;
